import PlatformStorage from "./PlatformStorage";

export default PlatformStorage;
export { PlatformStorage };
